import { Token } from '@getgo/auth-client'
import { getIsThirdPartyCookieDisabled } from '@buy/utils/get-is-thirdparty-cookie-disabled'

export enum SILENT_AUTH_EVENTS {
    FINISHED_SILENT_AUTH,
}

interface FinishedSilentAuthMessagePayload {
    name: SILENT_AUTH_EVENTS
    data: {
        success: boolean
        token: Token
    }
}

interface FinishedSilentAuthMessageEvent extends MessageEvent {
    data: FinishedSilentAuthMessagePayload
}

// This method is called in the parent frame
export const startSilentAuth = (resolve: (value: unknown) => void, url: string, silentAuthTicket: string) => {
    // First, set a session storage item to let the hidden iframe know we are using silent auth
    // (See where this is retreived at src/products/buy/saga/user/get-token.ts)
    window.sessionStorage.setItem('IsSilentAuth', 'true')

    // Then, add an event listener to wait for a message from the hidden iframe once it loads
    // (See where that message is sent below in endSilentAuth())
    window.addEventListener('message', (event: FinishedSilentAuthMessageEvent) => {
        if (event.origin === window.origin) {
            if (event.data.name === SILENT_AUTH_EVENTS.FINISHED_SILENT_AUTH && event.data.data.success === true) {
                const { token } = event.data.data
                window.sessionStorage.removeItem('IsSilentAuth')

                // The token gets sent back to /src/products/buy/saga/checkout-form/form-submission.ts
                // Search for "authClass.login" in that file
                resolve(token)
            }
        }
    })

    // Finally, redirect or create the hidden iframe, depending on whether third-party cookies are disabled
    // It will first load the auth site and then will be redirected back to
    // this frontend where the following file will pick up the
    // next step in the process: src/products/buy/saga/user/get-token.ts
    const isThirdPartyCookieDisabled = getIsThirdPartyCookieDisabled()
    const loginUrl = `${url}&ticket=${silentAuthTicket}`
    if (isThirdPartyCookieDisabled) {
        window.location.href = loginUrl
    } else {
        const iframe = document.createElement('iframe')
        iframe.src = loginUrl
        iframe.width = '0'
        iframe.height = '0'
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
    }
}

// This method is called from the hidden iframe
export const endSilentAuthFromIFrame = (token: Token) => {
    const event: FinishedSilentAuthMessagePayload = {
        name: SILENT_AUTH_EVENTS.FINISHED_SILENT_AUTH,
        data: { success: true, token },
    }
    // Pass control back to the parent frame
    // See window.addEventListener in this same file
    window.top!.postMessage(event)
}
